/**
 * This sets a CSS variable that has the height of the Collection Page header
 * Used to have a smoother transition for the Navigation Header, when the Collection Header is present
 */
// core version + navigation, pagination modules:


import Flyout from "//shop.darcsport.com/cdn/shop/t/175/assets/flyout.js?v=18950041428164779181775696196";

// configure Swiper to use modules
// Swiper.use([Navigation, Pagination]);




const setCollectionHeaderHeight = () => {
  const collectionHeaderEl = document.querySelector('.collection__header');

  if (collectionHeaderEl) {
    const collectionHeaderHeight = collectionHeaderEl.getBoundingClientRect().height;
    document.querySelector(':root').style.setProperty('--chh', `${collectionHeaderHeight}px`);
  }
}

window.addClassbyEventHover = () => {
    "use strict";
    !function (d, w, shop) {
        d.querySelectorAll(".collection-product__item.has-hover-image, .product-card.has-hover-image").forEach(function (productItem) {
            productItem.addEventListener("mouseenter", function () {
                productItem.querySelectorAll(".product__background-image").forEach(function (el) {
                    el.classList.add("hover");
                });
            });
            productItem.addEventListener("mouseout", function () {
                productItem.querySelectorAll(".product__background-image").forEach(function (el) {
                    el.classList.remove("hover");
                });
            });
        });
    }(document, window, Shopify);
}

function handleNavigationSwiper() {

    if (document.querySelector(".collection__swiper-container")) {
        var diffBetweenSlides = 24;
        var mySwiper = new Swiper('.collection__swiper-container .swiper-container', {
            slidesPerView: 'auto',
            spaceBetween: diffBetweenSlides,
            slidesOffsetAfter: 20,
            freeMode: true,
            loop: false
        });
    }
}

window.handleEndlessScroll = () => {
    const ajaxinateContainer = document.querySelector("#AjaxinateContainer");
    if (!ajaxinateContainer) return;

    const loadingMethod = ajaxinateContainer.dataset.ajaxinateMethod || 'scroll';
    let settings = {
        method: loadingMethod,
        container: '#AjaxinateContainer',
        pagination: '#AjaxinatePagination',
        offset: 100,
        loadingText: Shopify.theme.loadingText,
        callback: () => window.endlessScrollCallback()
    };

    if (window.innerWidth >= 800) {
        settings = {
            method: loadingMethod,
            container: '#AjaxinateContainer',
            pagination: '#AjaxinatePagination',
            offset: 1000,
            loadingText: Shopify.theme.loadingText,
            callback: () => window.endlessScrollCallback()
        };
    }

    return new Ajaxinate(settings);
}



window.endlessScrollCallback = () => {
    window.addClassbyEventHover();
    // add page count to URL
    let url = new URL(window.location.href);
    let page = parseInt(url.searchParams.get("page")) || 1;
    page++;
    url.searchParams.set("page", page);
    window.history.pushState({}, "", url);
}

document.addEventListener("DOMContentLoaded", function (e) {
  console.log("I AM RUNINSIDE2");
    window.addClassbyEventHover();
    handleNavigationSwiper();
    window.handleEndlessScroll();
    setCollectionHeaderHeight();

    document.querySelectorAll("[data-toogle-filter]").forEach(function (item, key) {
      console.log("I AM RUNINSIDE");
      item.addEventListener("click", function (e) {
        if (!window.filterFlyout) {
          let filterFlyout = document.getElementById('filters');
          if (filterFlyout) {
            try {
              const testFlyout = new Flyout(filterFlyout);
              window.filterFlyout = testFlyout;
            } catch (error) {
              console.error("Flyout is not defined", error);
            }
          }
        }
        if (window.filterFlyout && window.filterFlyout.open !== undefined) {
          window.filterFlyout.open = true;
        } else {
          console.error("filterFlyout is not properly initialized");
        }
      });
    });
});

/**
 * This is used to check if a user has visited a collection page once
 * during browsing, as on the first visit there's a slide preview animation
 * that plays on the first product card
 */
const checkFirstVisit = () => {
    const isRecurrentVisit = sessionStorage.getItem('recurrentVisit');

    if (isRecurrentVisit !== 'true') {
        sessionStorage.setItem('recurrentVisit', true);
    } else {
        const collectionContainer = document.querySelector('.collection__container');
        if(collectionContainer){
          collectionContainer.classList.remove('collection__container--first-visit');
        }
    }
}

document.addEventListener('DOMContentLoaded', () => {
    checkFirstVisit();
});